const config = {
    domainAPI: 'https://api.topiainvest.com.br',
  };
  
  export default config;